import { render, staticRenderFns } from "./LessonVideo.vue?vue&type=template&id=3d462e2c&scoped=true&"
import script from "./LessonVideo.vue?vue&type=script&lang=js&"
export * from "./LessonVideo.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d462e2c",
  null
  
)

export default component.exports